export const loadState = () => {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("state", serializedState);
  } catch (error) {
    console.log(error);
  }
};

const WIDGET_STATE_STORAGE_KEY = "widgetStateById";

const readWidgetStates = () => {
  try {
    const serialized = localStorage.getItem(WIDGET_STATE_STORAGE_KEY);
    return serialized ? JSON.parse(serialized) : {};
  } catch (_error) {
    return {};
  }
};

const writeWidgetStates = (states) => {
  try {
    localStorage.setItem(WIDGET_STATE_STORAGE_KEY, JSON.stringify(states));
  } catch (error) {
    console.log(error);
  }
};

export const getWidgetState = (widgetId, widgetState = {}) => {
  if (!widgetId) return undefined;

  if (widgetState && typeof widgetState === "object" && widgetId in widgetState) {
    return widgetState[widgetId];
  }

  const persistedStates = readWidgetStates();
  return persistedStates[widgetId];
};

export const setWidgetState = (widgetId, widgetState = {}, nextState = {}) => {
  if (!widgetId) return;

  const persistedStates = readWidgetStates();
  const previousState = (widgetState && widgetState[widgetId]) || persistedStates[widgetId] || {};
  const updatedState = { ...previousState, ...nextState };

  if (widgetState && typeof widgetState === "object") {
    widgetState[widgetId] = updatedState;
  }

  persistedStates[widgetId] = updatedState;
  writeWidgetStates(persistedStates);

  return updatedState;
};

/* New Implementation for the full screen navigation */
export const breakpoints = {
  xs: [0, 539],
  sm: [540, 767],
  md: [768, 959],
  lg: [960, 1139],
  xl: [1140, 1399],
  xxl: [1400, Infinity],
};

export const SET_NAVIGATION = "set-navigation";
export const GET_NAVIGATION = "get-navigation";
export const PUSH_SUBNAVIGATION = "push-subnavigation";
export const TOGGLE_NAV = "toggle-navigation";
export const SET_SUBHEADER_COMPONENTS = "set-subheader-components";
export const DELETE_SUBHEADER_COMPONENT = "delete-subheader-component"
export const CLEAR_SUBHEADER_COMPONENTS = "clear-subheader-components";

export const toggleNavigation = (show) => ({
  type: TOGGLE_NAV,
  open: show,
});

export const setNavigation = (navigation) => ({
  type: SET_NAVIGATION,
  navigation,
});

export const getNavigation = () => ({
  type: GET_NAVIGATION,
});

export const pushSubNavigation = (subNavigation) => ({
  type: PUSH_SUBNAVIGATION,
  subNavigation,
});

export const setSubHeaderComponents = (components) => ({
  type: SET_SUBHEADER_COMPONENTS,
  components,
});

export const deleteSubHeaderComponent = (widgetId) => ({
  type: DELETE_SUBHEADER_COMPONENT,
  widgetId,
});

export const clearSubHeaderComponents = (components) => ({
  type: CLEAR_SUBHEADER_COMPONENTS,
  components,
});

export const getCacheSubNavigationById = (state, id) => {
  return state.find((subNavigation) => subNavigation.id === id);
};

export const isSubNavigationExist = (subNavigations, id) => {
  return subNavigations?.some((item) => item.id === id);
};

export const getBreakpoint = () => {
  let windowWidth = window.innerWidth;
  // let windowHeight = window.innerHeight;
  let currentBreakpoint = "lg";

  for (let key in breakpoints) {
    //console.log(key, windowWidth, breakpoints[key][0], breakpoints[key][1]);

    if (
      windowWidth >= breakpoints[key][0] &&
      windowWidth <= breakpoints[key][1]
    ) {
      currentBreakpoint = key;
    } //if
  } //for

  return currentBreakpoint;
};
